import { render, staticRenderFns } from "./chat_group_add.vue?vue&type=template&id=50b50b66&scoped=true"
import script from "./chat_group_add.vue?vue&type=script&lang=js"
export * from "./chat_group_add.vue?vue&type=script&lang=js"
import style0 from "./chat_group_add.vue?vue&type=style&index=0&id=50b50b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b50b66",
  null
  
)

export default component.exports